export default function AppSection() {
  return (
    <section id="app" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-r from-primary-600 to-primary-800 rounded-xl overflow-hidden">
          <div className="flex-1 px-6 md:px-10 py-8 md:py-12 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              随时随地吃瓜
            </h2>
            <p className="text-primary-100 text-sm md:text-base leading-relaxed mb-6 max-w-md">
              下载吃瓜黑料爆料 APP，第一时间获取推送通知。明星出轨内幕、娱乐圈丑闻细节，不错过任何一个热点事件。离线阅读、夜间模式、个性化话题订阅，让吃瓜更尽兴。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-background-50 hover:bg-background-100 text-primary-700 font-semibold rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-apple-fill mr-2"></i>App Store 下载
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-foreground-900/30 hover:bg-foreground-900/50 text-background-50 border border-background-50/30 font-semibold rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-android-fill mr-2"></i>Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56 lg:w-64 px-6 pb-8 lg:pb-0 lg:pr-10 lg:py-6">
            <div className="aspect-[9/16] bg-background-50/10 rounded-xl border border-background-50/20 flex items-center justify-center overflow-hidden">
              <div className="text-center p-4">
                <i className="ri-smartphone-line text-4xl text-background-50/40 mb-2 block"></i>
                <span className="text-background-50/30 text-xs">扫码下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}